import React, { useState } from 'react';
import { firebaseServices } from '../../Firebase/FirebaseServices';
import './AdminLogin.css';



function AdminLogin() {
    let [credentials, setCredentials] = useState({ email: '', pass: '' })
    return (
        <div className="AdminLogin_mainDiv">
            <div className="layer">
                <div className="AdminLogin_credentialDiv">
                    <div className="AdminLogin_credentialDiv_heading">
                        <p>Admin Dashboard</p>
                    </div>

                    <form className='AdminLogin_credentialDiv_form_div'>
                        <div className="form-group credentialDiv_form-group">
                            <label className='credentialDiv_label' >Email</label>
                            <input type="email" className="form-control credentialDiv_input_field" id="inputEmail4" placeholder=""
                                onChange={(e) => { setCredentials({ ...credentials, email: e.target.value }) }} />
                        </div>

                        <div className="form-group credentialDiv_form-group">
                            <label className='credentialDiv_label' >Password</label>
                            <input type="Password" className="form-control credentialDiv_input_field" id="inputEmail4" placeholder=""
                                onChange={(e) => { setCredentials({ ...credentials, pass: e.target.value }) }} />
                        </div>
                    </form>

                    <div className='AdminLogin_buttonDiv'>
                        <button className='AdminLogin_button' onClick={() => {
                            firebaseServices.auth().signInWithEmailAndPassword(credentials.email, credentials.pass)
                                .then((e) => {
                                    // console.log(e)
                                })
                                .catch((error) => { alert(error) })
                        }}>Login</button>
                    </div>


                </div>
            </div>
        </div>
    )
}

export default AdminLogin;